import { arvoDocsPath, ARVO_DOCS_UI_PATH } from '@upright/common/arvo/docs/paths';

/**
 * The console's former docs pages (`/arvo/docs/<page>`, and `/arvo/agents` before them), and where
 * each now lives in the public docs (`/docs`). Links from the marketing site and bookmarks keep
 * landing; a page that is gone goes to the docs' start, except the skill page, which goes to the MCP
 * reference that took its place.
 */
const MOVED: Record<string, string> = {
  overview: arvoDocsPath('tutorials', 'agent'),
  authentication: arvoDocsPath('reference', 'authentication'),
  decide: arvoDocsPath('reference', 'api-cb-decision'),
  explicit: arvoDocsPath('tutorials', 'first-decision'),
  outcomes: arvoDocsPath('how-to', 'report-chosen-decisions'),
  revisions: arvoDocsPath('how-to', 'revise'),
  metadata: arvoDocsPath('how-to', 'metadata'),
  systemone: arvoDocsPath('tutorials', 'questions'),
  errors: arvoDocsPath('reference', 'errors'),
  mcp: arvoDocsPath('reference', 'mcp'),
  skill: arvoDocsPath('reference', 'mcp'),
  pricing: arvoDocsPath('reference', 'models-pricing'),
  'data-use': arvoDocsPath('how-to', 'retention'),
};

/** Where a console path that used to be a docs page now points; null for every other path. */
export function movedDocsPath(pathname: string): string | null {
  if (pathname === '/arvo/agents') return MOVED.mcp;
  const match = /^\/arvo\/docs(?:\/([^/]+))?\/?$/.exec(pathname);
  if (!match) return null;
  return match[1] ? (MOVED[match[1]] ?? ARVO_DOCS_UI_PATH) : ARVO_DOCS_UI_PATH;
}
